
namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    //export class ProductsFranchiseeDialog extends Serenity.PropertyDialog<any, any> {
    export class CustomerEnquiryDialog extends Serenity.EntityDialog<EnquiryRow, any> {
        protected getFormKey() { return CustomerEnquiryForm.formKey; }
        protected getIdProperty() { return EnquiryRow.idProperty; }
        protected getLocalTextPrefix() { return EnquiryRow.localTextPrefix; }
        protected getService() { return EnquiryService.baseUrl; }

        protected form = new CustomerEnquiryForm(this.idPrefix);
        public rowids: string;

        private checkGrid: EnquiryGrid;
        constructor(gridToRefresh, FormMode, selectedids) {
            super();
            this.form = new CustomerEnquiryForm(this.idPrefix);
            this.rowids = selectedids;
        }

        loadEntity(entity: EnquiryRow) {
            super.loadEntity(entity);
            this.form.RowIds.value = this.rowids;

            this.form.EStatus.changeSelect2(e => {
                var vEstatus = this.form.EStatus.value;
                if (this.isNew()) {
                    this.form.FollowupDate.getGridField().toggle(false);
                    /*if (Q.isEmptyOrNull(vEstatus)) {
                        // this.setProductDetails({});
                        this.form.FollowupDate.getGridField().toggle(false);
                    }
                    else*/ if (vEstatus == '2') {
                        this.form.FollowupDate.getGridField().toggle(true);
                    }
                    if (vEstatus == '1' || vEstatus == '3' || vEstatus == '4' || vEstatus == '5') {
                        this.form.FollowupDate.getGridField().toggle(false);
                    }
                }
            });
        }

        onSaveSuccess(response) {
            super.onSaveSuccess(response);
            if (this.form.RowIds.value != "") {
                Q.notifySuccess("Added sucessfully");
            }
        }
    }
}